/*
 * Copyright (C) 2023 - present Marek Kuzora - All Rights Reserved.
 */


import DynamicElement from 'fierry/rpc.old/dynamic-element';
import SessionModel from 'astro/server/session';

import Constants from 'astro/rpc/constants';

import Users from 'astro/rpc/users';
import Planet from 'astro/rpc/planet';

import * as Key from 'astro/rpc/key';
import * as Translator from 'astro/rpc/translator';


export default class extends DynamicElement
{
  constructor ()
  {
    super(SessionModel);

    this.constants = this.createElement('constants', new Constants());

    this.users = this.createElement('users', new Users());
    this.planets = this.createCollection('planets', (name) => new Planet(this.constants));

    this.createRecord('currentGalaxy', [ Translator.UpdateDate ]);
  }


  isReady ()
  {
    return super.isReady() && this.constants.isReady() && this.users.isReady();
  }

  // TODO can define different rpc execute methods here instead on the server ?
  // these would be visible from hierarchy but not state...
};
